import React, { useState, useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
// utils
import { OVERVIEW_FULL } from 'routes';
import { isEmpty } from 'lodash';
import { setCurrentMission } from 'store/actions/classroom';
import { useSelector, useDispatch } from 'react-redux';
// components
import MissionSidebar from 'components/MissionSidebar';
// icons
import { ReactComponent as ChevronIcon } from 'icons/chevron.svg';
// styles
import classnames from 'classnames/bind';
import styles from './Dashboard.module.scss';

const cx = classnames.bind(styles);

const Dashboard = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const { currentMission = {} } = useSelector(({ classroom: { currentMission } }) => ({
    currentMission,
  }));
  const { missions = [] } = useSelector(({ user }) => user);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleSelectMission = (data) => {
    localStorage.setItem('mission-id', data.id);
    dispatch(setCurrentMission(data));
    navigate(OVERVIEW_FULL);
  };

  // set default currentMission on init
  useEffect(() => {
    if (isEmpty(currentMission) && missions.length > 0) {
      const lastMission = missions.find(({ id }) => +id === +localStorage.getItem('mission-id'));
      dispatch(setCurrentMission(lastMission || missions[0]));
    }
  }, [missions, currentMission]);

  return (
    <div className={cx('container')}>
      <section className={cx('missions-wrapper', 'pdt-50')}>
        <span className={cx('mission-select-text', 'mgb-5')}>Select Mission</span>
        <ChevronIcon className={cx('mission-select-text-icon', 'mgb-10')} />
        {missions.map(({ id, image, ...rest }) => (
          <div
            key={`mission--${id}`}
            title="Select mission"
            className={cx('missions-wrapper--mission', 'mgb-10', { active: +id === +currentMission.id })}
            onClick={() => handleSelectMission({ id, image, ...rest })}
          >
            <img src={image} />
          </div>
        ))}
        <div className={cx('icon-wrapper', { open: sidebarOpen })} onClick={() => setSidebarOpen((prev) => !prev)}>
          <ChevronIcon className={cx('sidebar-menu-icon')} />
        </div>
      </section>
      <MissionSidebar isOpen={sidebarOpen} />
      <section className={cx('content-wrapper', 'pdv-50', 'pdh-90')}>
        <Outlet />
      </section>
    </div>
  );
};

export default Dashboard;
